module.exports = __webpack_public_path__ + "img/pc_popup.2fa9fc0c.png";